import { MobiDocument } from './MobiDocument';

export class ChampLibreResultValeurDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private inpa_champlibreresult_id: number;
    private listechamplibrevaleurs_id: number;

    public constructor(champLibreResultValeur: any) {
        super();
        this._id = champLibreResultValeur._id;
        this._rev = champLibreResultValeur._rev;
        this.inpa_champlibreresult_id = champLibreResultValeur.inpa_champlibreresult_id
        this.listechamplibrevaleurs_id = champLibreResultValeur.listechamplibrevaleurs_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getInpa_champlibreresult_id(): number {
        return this.inpa_champlibreresult_id;
    }

    public setInpa_champlibreresult_id(inpa_champlibreresult_id: number): void {
        this.inpa_champlibreresult_id = inpa_champlibreresult_id;
    }

    public getListechamplibrevaleurs_id(): number {
        return this.listechamplibrevaleurs_id;
    }

    public setListechamplibrevaleurs_id(listechamplibrevaleurs_id: number): void {
        this.listechamplibrevaleurs_id = listechamplibrevaleurs_id;
    }
}